/**************************************************
 * Nombre:       Home_Plan
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_seccion.svg'
import Tarjeta_Unica from "../../Tarjetas/Tarjeta_Unica";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Unica = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mb: 16}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 10}}>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: sCell ? 28 : 36, fontWeight: 600, lineHeight: 1.1}}>
                                Que hace a BitNova World única
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: 15, fontWeight: 400}}>
                                BitNova World combina innovación tecnológica, transparencia y accesibilidad con un
                                ecosistema en constante expansión, creando una experiencia de inversión distinta y con
                                visión de futuro.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={sCell ? 2 : 4}
                            >

                                {item.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Unica item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Unica

const item = [

    {
        nombre: 'Tecnología',
        descripcion: 'Basada en blockchain y algoritmos avanzados para mayor seguridad y eficiencia.'
    },
    {
        nombre: 'Transparencia',
        descripcion: 'Informes en tiempo real sobre el desempeño de tús inversiones.'
    },
    {
        nombre: 'Accesibilidad',
        descripcion: 'Diseñada tanto para usuarios principiantes como para inversores avanzados.'
    },
    {
        nombre: 'Expansión',
        descripcion: 'Como una nova, crece con fuerza e impulsa la participación en la economía descentralizada.'
    },

]